import React from 'react';
import {
  ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const data = [
  { state: 'New York', trucks: 3500, revenue: 492545 },
  { state: 'California', trucks: 3200, revenue: 482751 },
  { state: 'Texas', trucks: 2900, revenue: 437843 },
  { state: 'Florida', trucks: 2500, revenue: 434797 },
  { state: 'Illinois', trucks: 2100, revenue: 432238 },
  { state: 'Arizona', trucks: 1800, revenue: 443130 },
  { state: 'Nevada', trucks: 1500, revenue: 421244 },
  { state: 'Georgia', trucks: 1200, revenue: 400027 },
  { state: 'Nebraska', trucks: 900, revenue: 398542 },
  { state: 'Michigan', trucks: 800, revenue: 396000 },
  { state: 'Pennsylvania', trucks: 700, revenue: 390000 },
  { state: 'Ohio', trucks: 650, revenue: 385000 },
  { state: 'North Carolina', trucks: 600, revenue: 380000 },
  { state: 'Virginia', trucks: 550, revenue: 375000 },
  { state: 'Washington', trucks: 500, revenue: 370000 },
  { state: 'Massachusetts', trucks: 450, revenue: 365000 },
  { state: 'Tennessee', trucks: 400, revenue: 360000 },
  { state: 'Colorado', trucks: 350, revenue: 355000 },
  { state: 'Oregon', trucks: 300, revenue: 350000 },
  { state: 'Minnesota', trucks: 250, revenue: 345000 },
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { state, trucks, revenue } = payload[0].payload;
    return (
      <div className="bg-white p-2 border border-gray-300 rounded shadow">
        <p className="font-bold">{state}</p>
        <p>Number of Food Trucks: {trucks}</p>
        <p>Average Annual Revenue: ${revenue.toLocaleString()}</p>
      </div>
    );
  }
  return null;
};

const FoodTruckScatterPlot = () => (
  <div className="p-4 bg-white rounded shadow-md">
    <h2 className="text-xl font-semibold mb-4 text-center">Food Truck Industry Analysis by State (2024)</h2>
    
    {/* Scrollable wrapper for mobile */}
    <div className="overflow-x-auto">
      <div className="min-w-[600px]">
        <ResponsiveContainer width="100%" height={400}>
          <ScatterChart margin={{ top: 20, right: 20, bottom: 40, left: 80 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              type="number"
              dataKey="trucks"
              name="Number of Food Trucks"
              label={{ value: 'Number of Food Trucks', position: 'bottom', offset: 10 }}
            />
            <YAxis
              type="number"
              dataKey="revenue"
              name="Average Annual Revenue"
              tickFormatter={(tick) => `$${tick.toLocaleString()}`}
              label={{
                value: 'Average Annual Revenue ($)',
                angle: -90,
                position: 'insideLeft',
                offset: -50, // Ensures proper Y-axis label position
              }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Scatter name="States" data={data} fill="#3182ce" />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>

    <p className="text-sm text-gray-600 mt-4 text-center">
      Data sourced from <a href="https://www.foodtruckprofit.com/food-truck-revenue-by-state" className="text-blue-500">FoodTruckProfit.com</a> and <a href="https://www.uschamberfoundation.org/solutions/incubator/food-truck-nation" className="text-blue-500">U.S. Chamber of Commerce Foundation</a>.
    </p>
  </div>
);

export default FoodTruckScatterPlot;
